import { TableToggleRowsSelectedProps } from "react-table";
import { CheckBox } from "@shltelemedicine/shl-ui-lib";
type TableCheckBoxProps = {
  disabled?: boolean;
} & TableToggleRowsSelectedProps;

const TableCheckBox = ({ disabled, ...rest }: TableCheckBoxProps) => {
  // indeterminate is unused and log errors
  const { indeterminate, ...restOfCheckboxProps } = rest;

  return <CheckBox {...restOfCheckboxProps} disabled={disabled} />;
};
export default TableCheckBox;
